import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSemverComponent } from './simple-icons-semver.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSemverComponent ],
    exports:      [ SimpleIconsSemverComponent ],
    bootstrap:    []
})
export class SimpleIconsSemverModule {}
